import { useState, useEffect } from 'react';
import { message } from 'antd';
import {getStatus } from '../utils/licenseUtils';
import axios from "axios";

export const useLicenseKeys = () => {
    const [licenseKeys, setLicenseKeys] = useState([]);
    const [loading, setLoading] = useState(false);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 25,
        total: 0,
        hasNext: false,
        hasPrev: false
    });

    const createLicenseKey = async (values) => {
        setLoading(true);
        try {
            const requestData = {
                service_name: values.service_name,
                expire_at: values.expire_at.toISOString(),
                user: values.user
            };
            const res = await axios.post("/admin/license", requestData)
            await getLicenseKeys(1);
            message.success('License key created successfully');
            return true;
        } catch (error) {
            message.error('Failed to create license key');
            return false;
        } finally {
            setLoading(false);
        }
    };

    const getLicenseKeys = async (page = 1, pageSize = 25) => {
        setLoading(true);
        try {
            const offset = (page - 1) * pageSize;
            const params = {
                limit: pageSize + 1, // Request one extra item to check if there's a next page
                offset: offset,
                sort: 'created_at:desc'
            };

            const res = await axios.get("/admin/licenses", { params });

            const allData = res.data;
            const hasNext = allData.length > pageSize; // If we got more than pageSize, there's a next page
            const data = hasNext ? allData.slice(0, pageSize) : allData; // Remove the extra item

            setLicenseKeys(data);

            setPagination({
                current: page,
                pageSize: pageSize,
                total: null, //
                hasNext: hasNext,
                hasPrev: page > 1
            });

        } catch (error) {
            message.error('Failed to get license keys');
            return false;
        } finally {
            setLoading(false);
        }
    }

    const refreshData = async () => {
        setLoading(true);
        try {
            await getLicenseKeys(pagination.current, pagination.pageSize);
            message.success('Data refreshed successfully');
        } catch (error) {
            message.error('Failed to refresh data');
        } finally {
            setLoading(false);
        }
    };

    const goToNextPage = async () => {
        if (pagination.hasNext) {
            await getLicenseKeys(pagination.current + 1, pagination.pageSize);
        }
    };

    const goToPrevPage = async () => {
        if (pagination.hasPrev) {
            await getLicenseKeys(pagination.current - 1, pagination.pageSize);
        }
    };

    const getStatistics = () => {
        const activeCount = licenseKeys.filter(key => getStatus(key.expire_at) === 'active').length;
        const expiringCount = licenseKeys.filter(key => getStatus(key.expire_at) === 'expiring').length;
        const expiredCount = licenseKeys.filter(key => getStatus(key.expire_at) === 'expired').length;

        return {
            active: activeCount,
            expiring: expiringCount,
            expired: expiredCount,
            total: licenseKeys.length
        };
    };

    useEffect(()=>{
        getLicenseKeys(1);
    }, []);

    return {
        licenseKeys,
        loading,
        pagination,
        createLicenseKey,
        getLicenseKeys,
        goToNextPage,
        goToPrevPage,
        refreshData,
        getStatistics
    };
};